import { graphql, useStaticQuery } from "gatsby";
import { AllProducts } from "../utils/types";

export const useAllProducts: () => AllProducts = () => {
    const data = useStaticQuery(graphql`
    query AllProducts {
      allWcProducts {
        edges {
          node {
            id
            wordpress_id
            featured
            image {
              src
              id
              alt
              name
              localFile {
                extension
                internal{
                    mediaType
                }
                childrenImageSharp {
                  gatsbyImageData(
                    breakpoints: [300]
                    width: 300
                    quality: 80
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }
            price
            sale_price
            regular_price
            name
            defaultVariationID
            slug
            permalink
            average_rating
            on_sale
            rating_count
            status
            stock_status
            catalog_visibility
            date_created
            categories {
              slug
            }
            tags {
              slug
            }
            variations_product {
              id
              sale_price
              regular_price
              status
            }
          }
        }
      }
    }
  `);

    data.allWcProducts.edges = data.allWcProducts.edges.filter((edge) => edge.node.status === "publish")
    return data;
};
